/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentRequest } from './search-equipment-request';


export interface ChangeEquipmentScheduleAssignmentsByFilterRequest { 
    scheduleId?: string;
    filter?: SearchEquipmentRequest;
    excludeEquipmentIds?: Array<string> | null;
    replaceEquipmentIds?: Array<string> | null;
}

